module.exports = __webpack_public_path__ + "static/img/0542_7.800b942.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0542_7.jpg
// module id = GYOB
// module chunks = 1